import 'whatwg-fetch';
import 'url-search-params-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { setOptions, overrideComponent } from '@sheerid/jslib';
import { StepStudentPersonalInfoComponent } from './components/steps/StepStudentPersonalInfoComponent';
import { StepErrorComponent } from './components/steps/StepErrorComponent';
import './index.css';
import App from './App';

setOptions({
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },
    logLevel: 'error',
    messagesWithLocale: {
        'en-US' : {
            studentInfoShared: "Information entered here will be used for<br> verification purposes and shared with Skullcandy. ",
            "companyName": "Skullcandy",
            "schoolName" : "College Name",
            "firstName" : "First Name",
            "lastName" : "Last Name",
            "birthDate" : "Date of Birth",
            "emailAddress" : "Email Address",
            "emailExplanation": "Personal or school email is fine",
            "required" : "REQUIRED",
            "countries" : {
                "CA": "Canada"
            },
            "step": {
                "personalInfo": {
                    "emailExplanation": "Personal or school email is fine",
                    "required": "REQUIRED",
                    "title": "Verify Your Student Details",
                    "subtitle": "Verify you\'re a student at a degree-granting college or university.",
                },
                "docUpload": {
                    "title" : "We Need More Information",
                    "acceptedTypes" : "Files must be .jpg .png .pdf .gif or .bmp",
                    "submitButtonLabel": "Submit",
                    "subtitle": "Documents will be reviewed in a few minutes by staff at SheerID, a trusted partner.",
                    "rejectionReasons": {
                        "DOCUMENT_UNREADABLE": "The document you submitted was unreadable due to poor image quality. Please make sure you have a clearly legible image that's bright and crisp, and try submitting again.",
                        "DOCUMENT_PASSWORD_PROTECTED": "We are unable to accept password protected documents.",
                        "DOCUMENT_LIKELY_FRAUD": "The document you submitted is insufficient for establishing eligibility for this offer.",
                        "DOCUMENT_UNSUPPORTED": "The document you submitted is not on the list of accepted document types.",
                        "DOCUMENT_HANDWRITTEN": "We cannot accept handwritten documents.",
                        "DOCUMENT_WORD_DOC": "We cannot accept text copied and pasted from official documents. Please submit a screenshot or image of the official document.",
                        "MISSING_INFORMATION": "The document you submitted does not provide all of the information necessary to determine eligibility for this offer.",
                        "MISSING_INFORMATION_PERSON_NAME": "The document you submitted is missing a first and/or last name.",
                        "MISSING_INFORMATION_ORGANIZATION_NAME": "The document you submitted does not include an organization name that confirms your connection to that organization.",
                        "DOCUMENT_EXPIRED": "The document you submitted has expired.",
                        "DOCUMENT_OUTDATED": "The document you submitted is missing an issue date or was issued too far in the past.",
                        "DOCUMENT_OUTDATED_LAST_3_MONTHS": "The document you submitted is missing an issue date or was issued more than three months ago.",
                        "DOCUMENT_OUTDATED_LAST_6_MONTHS": "The document you submitted is missing an issue date or was issued more than six months ago.",
                        "DOCUMENT_OUTDATED_LAST_12_MONTHS": "The document you submitted is missing an issue date or was issued more than twelve months ago.",
                        "MISMATCH_PERSON_NAME": "The information on the document you submitted does not match the first and/or last name submitted on the verification form.",
                        "MISMATCH_ORGANIZATION": "The organization name on the document(s) you submitted does not match the organization you listed on the verification form.",
                        "MISMATCH_STATUS": "The status on the document you submitted does not match the status you listed on your verification form.",
                        "INELIGIBLE_ORGANIZATION": "The organization on the document you submitted is not eligible for this offer.",
                        "MISSING_INFORMATION_UNIVERSITY_ENROLLMENT": "The document you submitted does not prove enrollment in the current term.",
                        "MISMATCH_SCHOOL_NAME": "The school name on the document you submitted does not match the school name listed on the verification form.",
                        "INELIGIBLE_ORGANIZATION_UNIVERSITY_TITLE_IV": "The school listed on the document you submitted is not eligible for this offer because it is not a Title IV degree-granting college or university in the United States.",
                        "INELIGIBLE_ORGANIZATION_US_UNIVERSITY": "The school listed in the document you submitted is not eligible for this offer because it is not in the United States.",
                        "INELIGIBLE_PERSON_HIGH_SCHOOL_STUDENT": "High School Students are not eligible for this offer.",
                        "MISSING_INFORMATION_AFFILIATION_US_ARMED_FORCES": "The document you submitted is does not show affiliation to an eligible branch of the United States Armed Forces.",
                        "MISSING_INFORMATION_AFFILIATION_US_UNIFORMED_SERVICES": "The document you submitted does not show affiliation to an eligible branch of the United States Uniformed Services.",
                        "MISMATCH_COMPANY_NAME": "The company name on the document you submitted does not match the company name you listed on the verification form.",
                        "PAYSTUB_OUTDATED_LAST_30_DAYS": "Please upload a paystub that was issued within the last 30 days.",
                        "PAYSTUB_OUTDATED_LAST_60_DAYS": "Please upload a paystub that was issued within the last 60 days.",
                        "MISSING_INFORMATION_BIRTHDATE": "The document you submitted is missing a birthdate, or your age is ineligible for this offer.",
                        "MISMATCH_BIRTHDATE": "The birthdate on the document you submitted does not match the birthdate you listed on the verification form.",
                        "OTHER_CONTACT_US": "We are having problems verifying your eligibility for the offer. Please contact SheerID customer service for help: customerservice@sheerid.com",
                        "PERSON_FIELD_MISMATCH": "A field in the document provided did not match with what was provided on the verification form.",
                    }
                },
                "success": {
                    "subtitle": "Here is your personal coupon code.<br>It is unique to you and can only be used once.",
                    "redirectButtonText": "Continue",
                    "emailNotification": "We have emailed you a copy so you can use your code now or later.<br>Look for the email from verify@sheerid.com",
                    "verificationOnly": "SheerID handles verification only. Now that you've been approved,<br> please direct all questions about the promotion terms and/or code use to Skullcandy customer service.",
                },
                "pending": {
                    "title": "Processing",
                    "titleReview": "Processing",
                    "subtitle": "SheerID is reviewing your documents, to confirm you status.<br><br><b>This process may take up to 20 minutes.</b>",
                },
            },
        },
    }
});

// @ts-ignore
overrideComponent('StepStudentPersonalInfoComponent', StepStudentPersonalInfoComponent);
// @ts-ignore
overrideComponent('StepErrorComponent', StepErrorComponent);

ReactDOM.render(<App />, document.getElementById('root'));

